'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
var Icon = require('../../01.atoms/Icon/Icon.js');
var Expandable = require('../../01.atoms/Expandable/Expandable.js');
var Headline = require('../../01.atoms/Headline/Headline.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-text-expandable',
    cnExpanded = "".concat(CLASSNAME, "--expanded"),
    cnBody = "".concat(CLASSNAME, "__body"),
    cnWrapperInner = "".concat(CLASSNAME, "__wrapper-inner"),
    cnButton = "".concat(CLASSNAME, "__button"),
    cnIcon = "".concat(CLASSNAME, "__icon");
/**
 * 
 */

var TextExpandable = /*#__PURE__*/function (_React$Component) {
  _rollupPluginBabelHelpers.inherits(TextExpandable, _React$Component);

  var _super = _rollupPluginBabelHelpers.createSuper(TextExpandable);

  function TextExpandable() {
    var _this;

    _rollupPluginBabelHelpers.classCallCheck(this, TextExpandable);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "state", {
      expanded: false
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onExpandableMount", function (initialHeight) {
      // TODO move into Expandable
      var MIN_HEIGHT = _this.constructor.MIN_HEIGHT;

      if (initialHeight < MIN_HEIGHT) {
        _this.setState({
          expanded: true,
          notExpandable: true
        });
      }
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "toggleExpandState", function (e) {
      e.preventDefault();
      var expanded = _this.state.expanded;
      var onToggle = _this.props.onToggle;

      _this.setState({
        expanded: !expanded
      });

      onToggle(!expanded);
    });

    return _this;
  }

  _rollupPluginBabelHelpers.createClass(TextExpandable, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      var _this$state = this.state,
          expanded = _this$state.expanded,
          notExpandable = _this$state.notExpandable;
      return nextState.expanded !== expanded || nextState.notExpandable !== notExpandable;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          body = _this$props.body,
          titleMore = _this$props.titleMore,
          children = _this$props.children,
          iconId = _this$props.iconId,
          title = _this$props.title,
          _this$state2 = this.state,
          expanded = _this$state2.expanded,
          notExpandable = _this$state2.notExpandable,
          classes = [CLASSNAME, className];
      var MIN_HEIGHT = this.constructor.MIN_HEIGHT;
      return /*#__PURE__*/React__default.createElement("div", {
        className: classNames(classes, _rollupPluginBabelHelpers.defineProperty({}, cnExpanded, expanded))
      }, title && /*#__PURE__*/React__default.createElement(Headline, {
        level: 4,
        iconId: iconId
      }, title), /*#__PURE__*/React__default.createElement(Expandable, {
        className: cnBody,
        classNameContent: cnWrapperInner,
        expanded: expanded,
        onMount: this.onExpandableMount,
        minHeight: MIN_HEIGHT
      }, children, /*#__PURE__*/React__default.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: body
        }
      })), !notExpandable && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("button", {
        className: cnButton,
        onClick: this.toggleExpandState
      }, /*#__PURE__*/React__default.createElement("span", null, titleMore), /*#__PURE__*/React__default.createElement(Icon, {
        className: cnIcon,
        id: "caret-down",
        size: "xs"
      }))));
    }
  }]);

  return TextExpandable;
}(React__default.Component);

_rollupPluginBabelHelpers.defineProperty(TextExpandable, "MIN_HEIGHT", 300);
TextExpandable.propTypes = {
  /** Content text */
  body: PropTypes.string.isRequired,

  /** Child nodes */
  children: PropTypes.node,

  /** Additional class name */
  className: PropTypes.string,

  /** Id of icon */
  iconId: PropTypes.string,

  /** Callback function on toggle expanded */
  onToggle: PropTypes.func,

  /** Text to indicate there is more */
  titleMore: PropTypes.string,

  /** Headline */
  title: PropTypes.string
};
TextExpandable.defaultProps = {
  onToggle: function onToggle() {
    return void 0;
  },
  titleMore: 'read_more'
};

module.exports = TextExpandable;
